import { code, key } from '@connect-x-app/shared-test-ids';

export const FLIGHTROOM_TEST_IDS = {
  header: {
    notificationCenter: 'flightroom.header.button.notificationCenter',
    profile: 'flightroom.header.button.profile',
    search: 'flightroom.header.input.search',
    timeZone: 'flightroom.header.switch.timeZone',
    workstation: 'flightroom.header.button.workstation',
  },
  item: {
    airportIata: (alignment: 'left' | 'right') => `flightroom.item.text.airportIata.${alignment}`,
    airportIcao: (alignment: 'left' | 'right') => `flightroom.item.text.airportIcao.${alignment}`,
    assignTask: 'flightroom.item.button.assignTask',
    joinCheckIcon: 'flightroom.item.view.joinCheckIcon',
    joinPlusIcon: 'flightroom.item.view.joinPlusIcon',
    mentionIcon: 'flightroom.item.view.mentionIcon',
    notificationCounter: 'flightroom.item.view.notificationCounter',
    pendingRequestIcon: 'flightroom.item.view.pendingRequestIcon',
    row: (flightNumber: string) => `flightroom.item.row.${code(flightNumber)}`,
  },
  list: {
    rooms: 'flightroom.list.view.rooms',
    tabs: 'flightroom.list.view.tabs',
  },
  mute: {
    notifications: 'flightroom.mute.switch.notifications',
  },
  muteModal: {
    cancel: 'flightroom.muteModal.button.cancel',
    duration: 'flightroom.muteModal.select.duration',
    modal: 'flightroom.muteModal.modal.mute',
    submit: 'flightroom.muteModal.button.submit',
  },
  requestAccess: {
    cancel: 'flightroom.requestAccess.button.cancel',
    request: 'flightroom.requestAccess.button.request',
  },
  search: {
    joinTaskConfirmation: 'flightroom.search.modal.joinTaskConfirmation',
    results: 'flightroom.search.view.results',
  },
  workstation: {
    apply: 'flightroom.workstation.button.apply',
    bound: (name: string) => `flightroom.workstation.input.${key(name)}`,
    close: 'flightroom.workstation.button.close',
    criteria: (name: string) => `flightroom.workstation.select.${key(name)}`,
    delete: 'flightroom.workstation.button.delete',
    panel: 'flightroom.workstation.view.panel',
    reset: 'flightroom.workstation.button.reset',
    screen: 'flightroom.workstation.view.screen',
    section: (name: string) => `flightroom.workstation.view.${name}.section`,
  },
  workstationCollapse: {
    collapsible: 'flightroom.workstationCollapse.view.collapsible',
    pill: (pillKey: string) => `flightroom.workstationCollapse.pill.${key(pillKey)}`,
    singlePillContainer: 'flightroom.workstationCollapse.view.singlePillContainer',
  },
} as const;
